module.exports = __webpack_public_path__ + "static/img/icon_email.d371adae.svg";